module.exports = __webpack_public_path__ + "static/media/content-1.d33729c7.svg";